import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Status, StatusChange } from "@common/models";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { AuthenticationService } from ".";

@Injectable({ providedIn: "root" })
export class StatusChangeService {
  //Endpoint en api de common para StatusChange
  private statusChangeEndPoint = `${environment.commonApiUrl}/api/status-change`;

  constructor(private _http: HttpClient, private _authenticationService: AuthenticationService) {}

  /**
   * Obtiene los cambios de estado a través del Id del menu
   * @param {Number} menuId - Id del menu
   * @returns {Observable<StatusChange[]>} Respuesta del consumo de la API
   */
  getAllStatusChangeByMenu(menuId: number): Observable<StatusChange[]> {
    return this._http.get<StatusChange[]>(
      `${this.statusChangeEndPoint}/${menuId}`
    );
  }

  /**
   * Crea un nuevo cambio de estado
   * @param {StatusChange} statusChange - Nuevo cambio de estado a crear
   * @returns {Observable<{ message: string; statusChange: StatusChange }>} Respuesta del consumo de la API
   */
  createNewStatusChange(statusChange: StatusChange): Observable<{ message: string; statusChange: StatusChange; }> {
    return this._http.post<{ message: string; statusChange: StatusChange }>(
      this.statusChangeEndPoint,
      statusChange
    );
  }

  /**
   * Actualiza un cambio de estado a través de su ID
   * @param {StatusChange} statusChange - Cambio de estado a actualizar
   * @returns {Observable<{ message: string; statusChange: StatusChange }>} Respuesta del consumo de la API
   */
  updateStatusChange(statusChange: StatusChange): Observable<{ message: string; statusChange: StatusChange; }> {
    return this._http.put<{ message: string; statusChange: StatusChange }>(
      this.statusChangeEndPoint,
      statusChange
    );
  }

  /**
   * Elimina un cambio de estado a través de su ID
   * @param {StatusChange} statusChange - Cambio de estado a eliminar
   * @returns {Observable<{ message: string; statusChange: StatusChange }>} Respuesta del consumo de la API
   */
  deleteStatusChange(statusChange: StatusChange): Observable<{ message: string; statusChange: StatusChange; }> {
    return this._http.put<{ message: string; statusChange: StatusChange }>(
      `${this.statusChangeEndPoint}/${statusChange.id}/ELI`,
      null
    );
  }



  /**
   * Valida estatus de relación cambio de estado con grupos de usuarios
   * @param statusChange Cambio de estado a realizar
   * @param statusActive Estado activo para validación
   * @returns 
   */
  validateUserAndGroup(statusChange: StatusChange, statusActive: Status){

    if(statusChange && statusChange.statusChangeCollection && statusChange.statusChangeCollection.length == 0)
      return true;

    const collections = [...statusChange?.statusChangeCollection?.filter(i => i.status.id == statusActive.id)?.map(i => i.collection) ?? []];
    const collectionUsers = [].concat(...collections.filter(i => i.status.id == statusActive.id).map(i => i.collectionUsers));
    const allowedUsers = [].concat(collectionUsers.filter(i => i.status.id == statusActive.id).map(i => i.user))
    
    const userExist = allowedUsers.find(u => u.id == this._authenticationService.currentUserValue.id);

    return userExist;

  }

}
